// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Box, Typography, Button, Container, Paper } from '@mui/material';
// import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
// import EventIcon from '@mui/icons-material/Event';
// import EmailIcon from '@mui/icons-material/Email';

// const SuccessPage = () => {
//   const navigate = useNavigate();

//   return (
//     <Container maxWidth="sm" sx={{ py: { xs: 4, md: 6 } }}>
//       <Paper
//         elevation={3}
//         sx={{
//           borderRadius: '16px',
//           overflow: 'hidden',
//           p: { xs: 3, sm: 4 },
//         }}
//       >
//         {/* Success Header */}
//         <Box
//           sx={{
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             mb: 4,
//           }}
//         >
//           <CheckCircleOutlineIcon
//             sx={{
//               fontSize: { xs: 80, md: 100 },
//               color: '#4CAF50',
//               mb: 2,
//             }}
//           />
//           <Typography
//             variant="h4"
//             component="h1"
//             sx={{
//               fontWeight: 'bold',
//               fontSize: { xs: '24px', md: '32px' },
//               textAlign: 'center',
//             }}
//           >
//             Оплата успішна!
//           </Typography>
//           <Typography
//             variant="body1"
//             color="text.secondary"
//             sx={{
//               mt: 1,
//               textAlign: 'center',
//               fontSize: { xs: '16px', md: '18px' },
//             }}
//           >
//             Дякуємо за Вашу покупку!
//           </Typography>
//         </Box>

//         {/* Email Notification */}
//         <Box
//           sx={{
//             backgroundColor: '#F5F5F5',
//             borderRadius: '12px',
//             p: 3,
//             mb: 4,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             gap: 2,
//           }}
//         >
//           <EmailIcon sx={{ color: '#007AFF', fontSize: 28 }} />
//           <Typography variant="body1">
//             Квитки відправлено на Вашу електронну пошту
//           </Typography>
//         </Box>

//         {/* Action Button */}
//         <Button
//           variant="contained"
//           startIcon={<EventIcon />}
//           fullWidth
//           sx={{
//             py: 1.5,
//             backgroundColor: '#007AFF',
//             borderRadius: '8px',
//             '&:hover': { backgroundColor: '#005bb5' },
//           }}
//           onClick={() => navigate('/events')}
//         >
//           Повернутися до подій
//         </Button>

//         {/* Support Info */}
//         <Box
//           sx={{
//             mt: 4,
//             pt: 3,
//             borderTop: '1px solid #E0E0E0',
//             textAlign: 'center',
//           }}
//         >
//           <Typography variant="body2" color="text.secondary">
//             Маєте питання?
//           </Typography>
//           <Typography
//             variant="body2"
//             color="primary"
//             sx={{
//               cursor: 'pointer',
//               fontWeight: 'medium',
//               mt: 0.5,
//             }}
//             onClick={() => console.log('Contact support')}
//           >
//             Зв'яжіться з нашою службою підтримки
//           </Typography>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default SuccessPage;
import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import EventIcon from '@mui/icons-material/Event';
import EmailIcon from '@mui/icons-material/Email';
import AdBanner from '../AdBanner/AdBanner';
import { adBannerConfig } from '../AdBanner/adBannerConfig';
import { useMediaQuery, useTheme } from '@mui/material';

const SuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Проверяем, есть ли параметры от LiqPay
  const status = searchParams.get('status');
  const hasPaymentParams = searchParams.has('status');

  useEffect(() => {
    // Если есть параметры от LiqPay, но статус не успешный - редиректим на события
    if (hasPaymentParams && status !== 'success' && status !== 'sandbox') {
      console.log('Payment failed, redirecting to events...', status);
      // Небольшая задержка для показа состояния
      setTimeout(() => {
        window.location.href = 'https://toptickets.com.ua/events';
      }, 2000);
    }
  }, [hasPaymentParams, status]);

  // Определяем тип результата
  // const getResultType = () => {
  //   if (!hasPaymentParams) {
  //     return 'success'; // Обычная страница успеха без параметров
  //   }

  //   if (status === 'success' || status === 'sandbox') {
  //     return 'success';
  //   } else if (status === 'failure' || status === 'error') {
  //     return 'error';
  //   } else {
  //     return 'cancelled';
  //   }
  // };
  const getResultType = () => {
    if (!hasPaymentParams) {
      return 'neutral'; // ← новый статус для случая без параметров
    }

    if (status === 'success' || status === 'sandbox') {
      return 'success';
    } else if (status === 'failure' || status === 'error') {
      return 'error';
    } else {
      return 'cancelled';
    }
  };

  const resultType = getResultType();

  // Конфигурация для разных типов результатов
  const getResultConfig = () => {
    switch (resultType) {
      case 'neutral':
        return {
          icon: EventIcon,
          iconColor: '#007AFF',
          title: 'Дякуємо за візит!',
          subtitle: 'Ви повернулися на сайт без завершення оплати.',
          showEmailNotification: false,
          buttonText: 'Перейти до подій',
          buttonAction: () => navigate('/events'),
        };

      case 'success':
        return {
          icon: CheckCircleOutlineIcon,
          iconColor: '#4CAF50',
          title: 'Оплата успішна!',
          subtitle: 'Дякуємо за Вашу покупку!',
          showEmailNotification: true,
          buttonText: 'Повернутися до подій',
          buttonAction: () => navigate('/events'),
        };

      case 'error':
        return {
          icon: ErrorOutlineIcon,
          iconColor: '#F44336',
          title: 'Помилка оплати',
          subtitle: 'На жаль, оплата не була проведена',
          showEmailNotification: false,
          buttonText: 'Спробувати ще раз',
          buttonAction: () => {
            // Показываем сообщение о перенаправлении
            setTimeout(() => {
              window.location.href = 'https://toptickets.com.ua/events';
            }, 1000);
          },
        };

      case 'cancelled':
        return {
          icon: CancelOutlinedIcon,
          iconColor: '#FF9800',
          title: 'Оплата скасована',
          subtitle: 'Ви скасували процес оплати',
          showEmailNotification: false,
          buttonText: 'Повернутися до подій',
          buttonAction: () => {
            setTimeout(() => {
              window.location.href = 'https://toptickets.com.ua/events';
            }, 1000);
          },
        };

      default:
        return {
          icon: CheckCircleOutlineIcon,
          iconColor: '#4CAF50',
          title: 'Оплата успішна!',
          subtitle: 'Дякуємо за Вашу покупку!',
          showEmailNotification: true,
          buttonText: 'Повернутися до подій',
          buttonAction: () => navigate('/events'),
        };
    }
  };

  const config = getResultConfig();
  const IconComponent = config.icon;

  // Показываем сообщение о перенаправлении для неуспешных платежей
  if (hasPaymentParams && resultType !== 'success') {
    return (
      <Container maxWidth="sm" sx={{ py: { xs: 4, md: 6 } }}>
        <Paper
          elevation={3}
          sx={{
            borderRadius: '16px',
            overflow: 'hidden',
            p: { xs: 3, sm: 4 },
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              mb: 4,
            }}
          >
            <IconComponent
              sx={{
                fontSize: { xs: 80, md: 100 },
                color: config.iconColor,
                mb: 2,
              }}
            />
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 'bold',
                fontSize: { xs: '24px', md: '32px' },
                textAlign: 'center',
                mb: 2,
              }}
            >
              {config.title}
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                textAlign: 'center',
                fontSize: { xs: '16px', md: '18px' },
                mb: 3,
              }}
            >
              {config.subtitle}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Перенаправляємо на сторінку подій...
            </Typography>
          </Box>

          <Button
            variant="contained"
            startIcon={<EventIcon />}
            fullWidth
            sx={{
              py: 1.5,
              backgroundColor: '#007AFF',
              borderRadius: '8px',
              '&:hover': { backgroundColor: '#005bb5' },
            }}
            onClick={config.buttonAction}
          >
            {config.buttonText}
          </Button>

          {/* Рекламний банер для мобільних пристроїв */}
          {isMobile && <AdBanner config={adBannerConfig} />}
        </Paper>
      </Container>
    );
  }

  // Обычная страница успеха
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 4, md: 6 } }}>
      <Paper
        elevation={3}
        sx={{
          borderRadius: '16px',
          overflow: 'hidden',
          p: { xs: 3, sm: 4 },
        }}
      >
        {/* Success Header */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            mb: 4,
          }}
        >
          <IconComponent
            sx={{
              fontSize: { xs: 80, md: 100 },
              color: config.iconColor,
              mb: 2,
            }}
          />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '24px', md: '32px' },
              textAlign: 'center',
            }}
          >
            {config.title}
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              mt: 1,
              textAlign: 'center',
              fontSize: { xs: '16px', md: '18px' },
            }}
          >
            {config.subtitle}
          </Typography>
        </Box>

        {/* Email Notification - только для успешных платежей */}
        {config.showEmailNotification && (
          <Box
            sx={{
              backgroundColor: '#F5F5F5',
              borderRadius: '12px',
              p: 3,
              mb: 4,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <EmailIcon sx={{ color: '#007AFF', fontSize: 28 }} />
            <Typography variant="body1">
              Квитки відправлено на Вашу електронну пошту
            </Typography>
          </Box>
        )}

        {/* Action Button */}
        <Button
          variant="contained"
          startIcon={<EventIcon />}
          fullWidth
          sx={{
            py: 1.5,
            backgroundColor: '#007AFF',
            borderRadius: '8px',
            '&:hover': { backgroundColor: '#005bb5' },
          }}
          onClick={config.buttonAction}
        >
          {config.buttonText}
        </Button>

        {/* Рекламний банер для мобільних пристроїв */}
        {isMobile && <AdBanner config={adBannerConfig} />}

        {/* Support Info */}
        <Box
          sx={{
            mt: 4,
            pt: 3,
            borderTop: '1px solid #E0E0E0',
            textAlign: 'center',
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Маєте питання?
          </Typography>
          <Typography
            variant="body2"
            color="primary"
            sx={{
              cursor: 'pointer',
              fontWeight: 'medium',
              mt: 0.5,
            }}
            onClick={() => console.log('Contact support')}
          >
            Зв'яжіться з нашою службою підтримки
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default SuccessPage;
